import { memo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Spacings, Fonts } from '@styles/index';
import Desktop from '@icon/Desktop';
import Mobile from '@icon/Mobile';

const IconBackground = styled.div`
  border: ${({ $isSelected, $color }) => $isSelected && `1px solid ${$color}`};
  border-radius: ${Spacings.SPACING_2B};
  margin-bottom: ${Spacings.SPACING_10B};
  background-color: ${({ $bgColor }) => $bgColor};
  padding: ${Spacings.SPACING_3B} ${Spacings.SPACING_4B};
  width: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;

  span {
    margin-left: ${Spacings.SPACING_4B};
    color: ${({ $color }) => $color};
    font-weight: ${Fonts.SEMIBOLD};
    font-size: ${Fonts.LARGE};
  }
`;

const PreviewIcon = ({ isDesktop, isSelected }) => {
  if (isDesktop) {
    return (
      <IconBackground
        $color="#7D57EB"
        $bgColor="#F4F1FF"
        $isSelected={isSelected}
      >
        <Desktop
          viewBox="0 0 24 24"
          size="24"
          pathFillRule="evenodd"
          pathClipRule="evenodd"
          stroke="#7D57EB"
          strokeWidth="2"
          color="none"
        />
        <span>Web preview</span>
      </IconBackground>
    );
  }

  return (
    <IconBackground
      $color="#F48E00"
      $bgColor="#FFF7EC"
      $isSelected={isSelected}
    >
      <Mobile
        viewBox="0 0 24 24"
        size="24"
        pathFillRule="evenodd"
        pathClipRule="evenodd"
        stroke="#F48E00"
        strokeWidth="2"
        color="none"
      />
      <span>Mobile preview</span>
    </IconBackground>
  );
};

export default memo(PreviewIcon);

PreviewIcon.propTypes = {
  isDesktop: PropTypes.bool,
  isSelected: PropTypes.bool
};

PreviewIcon.defaultProps = {
  isDesktop: true,
  isSelected: false
};
